import Api from './api.js';
import axios from 'axios';

export class ContactsApi extends Api {
    constructor(options = {}) {
        super(options);

        this.contactsApiPath = 'contactos';
    }

    async getContactsList(){
        return await this.axiosInstance.request({
            method: 'get',
            url: this.contactsApiPath,
        });
    }
}
